exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content-packs-versions{overflow-x:visible}", ""]);

// exports
